export default __webpack_public_path__ + "static/pam-11855e1c372d11a1ad5f54f43ba527c7.png";